import { Query } from '@/app/tracking/api';
import { SectionState } from './section-state'

export interface QuerySectionStatesTrackingQueryPayload {
}

export interface QuerySectionStatesTrackingQueryResult {
  sections: SectionState[]
}

export const QuerySectionStatesTrackingQueryName = 'query-section-states' as const
export type QuerySectionStatesTrackingQuery =
      Query<typeof QuerySectionStatesTrackingQueryName, QuerySectionStatesTrackingQueryPayload, QuerySectionStatesTrackingQueryResult>
